


import React, { useState, useEffect } from "react";
import { Link } from "react-router-dom";
import { FaUtensils, FaConciergeBell, FaStore, FaBuilding, FaShoppingBasket } from "react-icons/fa";
import Cloudbannerall from "./Cloudbannerall";
import Gelerycards from "./Gelerycards";
import "./Mainladdingpage.css";
import Mainnavbar from './Mainnavbar';
import Cateringbanner from './Cateringbanner.js';
import Franchiessbanner from './Franchiessbanner';
import Banquethallbanner from './Banquethallbanner';
import menu1 from "./download.jpg";
import LocalShippingIcon from '@mui/icons-material/LocalShipping';
import Logisticsbanner from "./Logisticsbanner"
import Mainlandingadvertise from "./Mainlandingadvertise.js";


const Landingpagesubscription = () => {
    const [activeFilter, setActiveFilter] = useState("Food & Beverages");
    const [coupons, setCoupons] = useState([]);
    const [isHovered, setIsHovered] = useState(false);
    const isMobile = window.innerWidth <= 768;
    const dishImages = {
        1: { image: menu1 },
        2: { image: menu1 },
        3: { image: menu1 },
    };
    useEffect(() => {
        setCoupons([
            { code: "PIZZA50", discountPercentage: 50, dishId: 1 },
            { code: "BURGER30", discountPercentage: 30, dishId: 2 },
            { code: "DEL99", discountPercentage: 20, dishId: 3 },
        ]);
    }, []);

    const orderPosts = [
        { dishId: 1, orderType: "Create Limited-Time Deals!" },
        { dishId: 2, orderType: "Highlight Your Best Sellers!" },
        { dishId: 3, orderType: "Exclusive Discount Campaigns" },
        { dishId: 4, orderType: "Create Your Festive Offers" },
        { dishId: 5, orderType: "Create Your Festive Best Deals" },
        { dishId: 6, orderType: "Create Your Own Ads" },
        { dishId: 7, orderType: "Target Local Customers" },
        { dishId: 8, orderType: "Maximize Visibility" },
        { dishId: 9, orderType: "Boost Seasonal Sales" },
        { dishId: 10, orderType: "Create Exclusive Coupons" },
    ];

    const renderContent = () => {
        switch (activeFilter) {
            case "Food & Beverages":
                return <Cloudbannerall />;
                // case "Catering & Services":
                //     return <Cateringbanner />;
                // case "Logistics & Supply":
                //     return <Logisticsbanner />;
                // case "Fresh & Grocery":
                //     return <Franchiessbanner />;
                // case "Banquet Hall":
                //     return <Banquethallbanner />;
                // default:
                return <Cloudbannerall />;
        }
    };

    const filterOptions = [
        { name: "Food & Beverages", icon: <FaUtensils /> },
        // { name: "Catering & Services", icon: <FaConciergeBell /> },
        // { name: "Logistics & Supply", icon: <LocalShippingIcon /> },
        // { name: "Fresh & Grocery", icon: <FaShoppingBasket /> }, // Grocery category
        // { name: "Banquet Hall", icon: <FaBuilding /> },
    ];

    return (
        <div>
            <p
                className="breadcrumb maamaas-home-bredcum"
                style={{
                    position: "fixed",
                    top: window.innerWidth <= 425 ? " 50px" : window.innerWidth > 425 && window.innerWidth <= 768 ? "60px" : "64px",
                    left: "2vw",
                    width: "100%",
                    backgroundColor: "#fff",
                    zIndex: window.innerWidth <= 998 ? 1000 : 1000,
                    padding: "10px 0",
                    fontSize: isMobile ? "16px" : "18px",
                    fontWeight: isMobile ? "normal" : "bold",
                    textAlign: "center",
                    margin: 0,
                }}
            >
                <Link
                    to="/fooddashboard"
                    style={{
                        color: "purple",
                        fontWeight: "bold",
                        textDecoration: "none",
                    }}
                >
                    Home
                </Link>
                <span className="separator"> &gt; </span>
                <Link
                    // to="/foodladingpage"
                    style={{
                        color: "purple",
                        fontWeight: "bold",
                        textDecoration: "none",
                    }}
                >
                    Subscription
                </Link>

                {/* <span className="separator"> &gt; </span> */}



            </p>
            <Mainnavbar />
            <div style={{ justifyContent: 'center' }} className="container-fluid main-container">
                <div className="row">
                    {/* Sidebar */}
                    <div className="col-lg-2 col-md-12 col-sm-12 sidebar">
                        <ul className="filter-list" style={{marginTop:"10px"}}>
                            {filterOptions.map((item) => (
                                <li
                                    key={item.name}
                                    className={`filter-item ${activeFilter === item.name ? "active" : ""}`}
                                    onClick={() => setActiveFilter(item.name)}
                                >
                                    <span className="icon">{item.icon}</span>
                                    <span className="text">{item.name}</span>
                                </li>
                            ))}
                        </ul>
                    </div>

                    {/* Content */}
                    <div
                        className="col-lg-8 col-md-12 col-sm-12 content-area"
                        style={{ height: "85vh", overflow: "auto", scrollbarWidth: "none", }}
                    >


                        <div style={{ padding: "15px", marginTop: "50px" }} className="main-banner-mobile">{renderContent()}</div>
                    </div>

                    {/* Right Panel (Hidden on Mobile) */}
                    <div className="col-lg-2 col-md-12 col-sm-12 right-panel">
                        <div className="right-panel-inner">

                            {/* {orderPosts.map((post, index) => (
                                <div
                                    key={`${post.dishId}-${index}`}
                                    className="promotion-card"
                                >
                                    <h6>{post.orderType}</h6>
                                    <Link to="/promotions" className="promotion-link">
                                        <button className="promotion-button">
                                            Add Promotions
                                        </button>
                                    </Link>
                                </div>
                            ))} */}
                            <Mainlandingadvertise />


                        </div>
                    </div>
                </div>
            </div>

            {/* Internal CSS for responsiveness */}
            <style>
                {`
          .sidebar {
            padding: 15px;
          }

          .filter-list {
            list-style: none;
            padding: 0;
          }

          .filter-item {
            display: flex;
            align-items: center;
            gap: 10px;
            padding: 10px;
            cursor: pointer;
            border-radius: 6px;
          }

          .filter-item.active {
            background: #b15cd6;
            color: #fff;
          }

          .filter-item:hover {
            background: #f2e6f9;
          }

          /* Hide right panel on tablets and below */
          @media (max-width: 991px) {
            .right-panel {
              display: none !important;
            }
          }

          /* Sidebar full width on mobile */
          @media (max-width: 768px) {
            .sidebar {
              width: 100% !important;
              margin-bottom: 10px;
              background: #fafafa;
              border-bottom: 1px solid #ddd;
            }
            .filter-item {
              justify-content: flex-start;
            }
            .content-area {
              margin-top: 15px;
            }
              .main-banner-mobile{
              width:96vw !important;
              }
              .main-container{
              margin-top:15px !important;
              }
          }
       
        `}
            </style>
        </div>
    );
};

export default Landingpagesubscription;

